import { render, staticRenderFns } from "./RightCenter.vue?vue&type=template&id=4d054b7e&scoped=true"
import script from "./RightCenter.vue?vue&type=script&lang=js"
export * from "./RightCenter.vue?vue&type=script&lang=js"
import style0 from "./RightCenter.vue?vue&type=style&index=0&id=4d054b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d054b7e",
  null
  
)

export default component.exports